import api from '@pray/shared/utils/api';

export const getAllLeadCampaigns = async ({
  offset = 0,
  limit = 0,
  sortColumn = '',
  sortDirection = 'asc',
  options = {},
  search = '',
  // Filter params
  status = '',
  leadClientId = '',
  type = '',
  popupEnabled = null,
  placement = '',
  platform = '',
  artistId = '',
  // Inclusive ISO 8601 bounds on when leads came in; they narrow the lead counts, not the campaigns
  leadsFrom = '',
  leadsTo = '',
} = {}) => {
  const params = {};

  if (offset) params.offset = offset;

  if (limit) params.limit = limit;

  if (search) params.search = search;

  if (sortColumn) {
    params.sort_column = sortColumn;
    params.sort_direction = sortDirection;
  }

  // Filter params
  if (status) params.status = status;
  if (leadClientId) params.lead_client_id = leadClientId;
  if (type) params.type = type;
  if (popupEnabled !== null) params.popup_enabled = String(popupEnabled);
  if (placement) params.placement = placement;
  if (platform) params.platform = platform;
  if (artistId) params.artist_id = artistId;
  if (leadsFrom) params.leads_from = leadsFrom;
  if (leadsTo) params.leads_to = leadsTo;

  const url = `/web/studio/lead-campaigns`;
  const response = await api.executeGetRequest(url, params, options);

  return response.data;
};
